<div class="bk-breadcrumb bk-container">
  <a routerLink="/">Home</a>
  <app-icon name="chevron-right" [size]="14" />
  <a routerLink="/select-seats">Select Seats</a>
  <app-icon name="chevron-right" [size]="14" />
  <span>Checkout</span>
</div>

<div class="bk-page">
  <div class="bk-container">
    <button type="button" class="bk-back" (click)="back()">
      <app-icon name="arrow-left" [size]="18" />
      <span>Back to seat selection</span>
    </button>

    <h1 class="bk-title checkout__title">Checkout</h1>

    <div class="checkout__layout">
      <div class="checkout__main">
        <section class="bk-card checkout__section">
          <h2 class="checkout__section-title">Passenger Information</h2>
          <div class="checkout__grid">
            <label class="checkout__field">
              <span>First Name *</span>
              <input [ngModel]="firstName()" (ngModelChange)="firstName.set($event)" name="firstName" placeholder="Juan" />
            </label>
            <label class="checkout__field">
              <span>Last Name *</span>
              <input [ngModel]="lastName()" (ngModelChange)="lastName.set($event)" name="lastName" placeholder="Dela Cruz" />
            </label>
            <label class="checkout__field">
              <span>Email</span>
              <input type="email" [ngModel]="email()" (ngModelChange)="email.set($event)" name="email" placeholder="juan@email.com" />
            </label>
            <label class="checkout__field">
              <span>Phone Number</span>
              <input [ngModel]="phone()" (ngModelChange)="phone.set($event)" name="phone" placeholder="09XX XXX XXXX" />
            </label>
          </div>
          <p class="checkout__hint">Your e-ticket will be sent via email and SMS.</p>
        </section>

        <section class="bk-card checkout__section">
          <h2 class="checkout__section-title">
            <app-icon name="users" [size]="18" /> Fare discounts
          </h2>
          @if (availableDiscounts().length === 0) {
            <p class="checkout__hint">No student, PWD, or senior discounts are available for this trip.</p>
          } @else {
            <div class="checkout__concessions">
              @for (rule of availableDiscounts(); track rule.id) {
                <div class="checkout__concession">
                  <div>
                    <strong>{{ rule.title }}</strong>
                    <p>{{ discountLabel(rule) }}{{ rule.requiresId ? ' · valid ID required' : '' }}</p>
                  </div>
                  <input
                    type="number"
                    [min]="concessionMin(rule.kind)"
                    [max]="selectedSeats().length"
                    [ngModel]="rule.kind === 'pwd' ? pwdPax() : rule.kind === 'senior' ? seniorPax() : studentPax()"
                    (ngModelChange)="setConcession($any(rule.kind), +$event)"
                    [name]="'concession-' + rule.kind"
                  />
                </div>
              }
            </div>
            <p class="checkout__hint">Enter how many passengers qualify. Total cannot exceed your seat count.</p>
            @if (minPwd() > 0 || minSenior() > 0) {
              <p class="checkout__hint">
                Reserved PWD/senior seats require that discount. You can add more
                qualifying passengers, but you cannot go below the seats you selected.
              </p>
            }
          }
        </section>

        <section class="bk-card checkout__section">
          <h2 class="checkout__section-title">
            <app-icon name="tag" [size]="18" /> Promo Code
          </h2>
          <div class="checkout__promo">
            <input
              class="checkout__promo-input"
              [ngModel]="promoCode()"
              (ngModelChange)="promoCode.set($event)"
              name="promoCode"
              placeholder="ENTER PROMO CODE"
            />
            <button type="button" class="bk-btn bk-btn--ghost" (click)="applyPromo()">Apply</button>
          </div>
          @if (promoError()) {
            <p class="bk-error checkout__promo-error">{{ promoError() }}</p>
          }
        </section>

        <section class="bk-card checkout__section">
          <h2 class="checkout__section-title">
            <app-icon name="mail" [size]="18" /> E-Ticket Delivery
          </h2>
          <ul class="checkout__delivery">
            <li>
              <app-icon name="mail" [size]="18" />
              <div>
                <strong>Via Email</strong>
                <p>Your e-ticket with QR code and booking reference will be sent to your email address.</p>
              </div>
            </li>
            <li>
              <app-icon name="smartphone" [size]="18" />
              <div>
                <strong>Via SMS</strong>
                <p>A booking code will be sent to your phone number for quick boarding.</p>
              </div>
            </li>
            <li>
              <app-icon name="printer" [size]="18" />
              <div>
                <strong>Print at Terminal</strong>
                <p>You can also present your booking code at any terminal counter to print a physical ticket.</p>
              </div>
            </li>
          </ul>
        </section>

        <section class="bk-card checkout__section">
          <h2 class="checkout__section-title">Payment Method</h2>
          <p class="checkout__hint">
            You will finish payment on Starpay. GCash, Maya, card, and QR Ph are available there.
          </p>
          <div class="checkout__payments">
            @for (method of paymentMethods; track method.id) {
              <label
                class="checkout__payment"
                [class.checkout__payment--active]="paymentMethod() === method.id"
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  [value]="method.id"
                  [ngModel]="paymentMethod()"
                  (ngModelChange)="paymentMethod.set($event)"
                />
                <app-icon [name]="method.icon" [size]="20" />
                <div>
                  <strong>{{ method.label }}</strong>
                  <p>{{ method.description }}</p>
                </div>
              </label>
            }
          </div>
        </section>

        <label class="checkout__terms">
          <input type="checkbox" [ngModel]="agreeToTerms()" (ngModelChange)="agreeToTerms.set($event)" name="agree" />
          <span>
            I agree to the <a href="#">Terms &amp; Conditions</a> and
            <a href="#">Refund Policy</a>. I understand that cancellation fees may apply.
          </span>
        </label>

        @if (error()) {
          <p class="bk-error checkout__error">{{ error() }}</p>
        }
      </div>

      <aside class="checkout__summary bk-card">
        <h2 class="checkout__section-title">Order Summary</h2>

        @if (schedule(); as s) {
          <div class="checkout__summary-trip">
            <app-icon name="bus" [size]="18" />
            <div>
              @if (isRoundTrip()) {
                <span class="checkout__leg-label">Departing</span>
              }
              <strong>{{ s.origin }} &rarr; {{ s.destination }}</strong>
              <p>{{ dateLabel() }} &middot; {{ s.busTypeName }} &middot; {{ formatTime(s.departureTime) }}</p>
            </div>
          </div>
          <div class="checkout__summary-seats">
            <span class="seats__panel-label">Departing seats</span>
            <div class="seats__chips">
              @for (seat of selectedSeats(); track seat.row + '-' + seat.column) {
                <span class="seats__chip">{{ seat.seatNumber }}</span>
              }
            </div>
          </div>
        }

        @if (isRoundTrip()) {
          @if (returnSchedule(); as r) {
            <div class="checkout__summary-trip">
              <app-icon name="bus" [size]="18" />
              <div>
                <span class="checkout__leg-label">Return</span>
                <strong>{{ r.origin }} &rarr; {{ r.destination }}</strong>
                <p>{{ returnDateLabel() }} &middot; {{ r.busTypeName }} &middot; {{ formatTime(r.departureTime) }}</p>
              </div>
            </div>
            <div class="checkout__summary-seats">
              <span class="seats__panel-label">Return seats</span>
              <div class="seats__chips">
                @for (seat of returnSeats(); track seat.row + '-' + seat.column) {
                  <span class="seats__chip">{{ seat.seatNumber }}</span>
                }
              </div>
            </div>
          }
        }

        <div class="checkout__summary-line">
          <span>Subtotal ({{ seatCount() }} seat{{ seatCount() > 1 ? 's' : '' }})</span>
          <span>{{ formatCurrency(subtotal()) }}</span>
        </div>
        @if (discount() > 0) {
          @if ((quote()?.concessionDiscount ?? 0) > 0) {
            <div class="checkout__summary-line checkout__summary-discount">
              <span>Fare discounts</span>
              <span>-{{ formatCurrency(quote()!.concessionDiscount) }}</span>
            </div>
          }
          @if ((quote()?.promoDiscount ?? 0) > 0) {
            <div class="checkout__summary-line checkout__summary-discount">
              <span>{{ appliedPromo() ? 'Promo (' + appliedPromo() + ')' : 'Route discount' }}</span>
              <span>-{{ formatCurrency(quote()!.promoDiscount) }}</span>
            </div>
          }
        }
        <div class="checkout__summary-line">
          <span>Transaction fee</span>
          <span>{{ formatCurrency(transactionFee()) }}</span>
        </div>
        <div class="checkout__summary-line checkout__summary-total">
          <span>Total</span>
          <span>{{ formatCurrency(total()) }}</span>
        </div>

        <button
          type="button"
          class="bk-btn bk-btn--primary bk-btn--block"
          [disabled]="!canPay()"
          (click)="pay()"
        >
          <app-icon name="lock" [size]="16" />
          @if (submitting()) {
            <span>Processing&hellip;</span>
          } @else {
            <span>Pay {{ formatCurrency(total()) }}</span>
          }
        </button>
        <p class="checkout__secure">
          <app-icon name="lock" [size]="12" /> Secured by Starpay
        </p>
      </aside>
    </div>
  </div>
</div>
